module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "createbaselinemodal",
    attrs: {
      "id": "create-baseline-modal",
      "name": "create-baseline-modal",
      "title": "Create a baseline",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Create",
      "ok-disabled": !_vm.baselineName,
      "close-title": "Cancel",
      "hide-header-close": ""
    },
    on: {
      "shown": _vm.shown,
      "cancel": _vm.handleCancel,
      "ok": _vm.handleOk
    }
  }, [_c('form', {
    attrs: {
      "id": "create-baseline-form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "id": "baseline-name",
      "placeholder": "Baseline name",
      "data-vv-name": "name"
    },
    model: {
      value: (_vm.baselineName),
      callback: function($$v) {
        _vm.baselineName = $$v
      },
      expression: "baselineName"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    attrs: {
      "name": "warning"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-form-textarea', {
    attrs: {
      "placeholder": "Description",
      "rows": 2,
      "max-rows": 6
    },
    model: {
      value: (_vm.baselineDescription),
      callback: function($$v) {
        _vm.baselineDescription = $$v
      },
      expression: "baselineDescription"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-form-group', [_c('b-form-radio-group', {
    attrs: {
      "id": "radios2",
      "stacked": ""
    },
    model: {
      value: (_vm.selectRequirementsOption),
      callback: function($$v) {
        _vm.selectRequirementsOption = $$v
      },
      expression: "selectRequirementsOption"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": 'all'
    }
  }, [_vm._v("Baseline all requirements in this project")]), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "value": 'folder'
    }
  }, [_vm._v("Baseline all requirements in a folder")]), _vm._v(" "), (_vm.selectRequirementsOption === 'folder') ? _c('folders-list', {
    attrs: {
      "folders": _vm.folders
    }
  }) : _vm._e(), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "value": 'individual'
    }
  }, [_vm._v("Select individual requirements in this project to baseline")])], 1)], 1), _vm._v(" "), (_vm.selectRequirementsOption === 'individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.requirements,
      "multiple": true,
      "custom-label": _vm.customRequirementLabel,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": "Select requirement(s)",
      "label": "name",
      "track-by": "requirement_id"
    },
    model: {
      value: (_vm.selectedRequirements),
      callback: function($$v) {
        _vm.selectedRequirements = $$v
      },
      expression: "selectedRequirements"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v("This will be added to project "), _c('strong', [_vm._v(_vm._s(_vm.currentProject.name))])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Creating\n  ")], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb35fad2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CreateBaselineModal.vue
// module id = 1027
// module chunks = 1